import { render, staticRenderFns } from "./OfferCard.vue?vue&type=template&id=cafd0660&scoped=true&"
import script from "./OfferCard.vue?vue&type=script&lang=js&"
export * from "./OfferCard.vue?vue&type=script&lang=js&"
import style0 from "./OfferCard.vue?vue&type=style&index=0&id=cafd0660&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cafd0660",
  null
  
)

export default component.exports